// Touch device interaction for paya pals
        document.querySelectorAll('.paya-pal').forEach(pal => {
            pal.addEventListener('touchstart', () => {
                pal.classList.add('is-touch-active');
            }, { passive: true });
            pal.addEventListener('touchend', () => {
                setTimeout(() => pal.classList.remove('is-touch-active'), 600);
            }, { passive: true });
        });
